/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import get from 'lodash/get';

import Button from '../Button';
import ErrorBlock from '../common/ErrorBlock';
import TermsContent from '../TermsAndConditions/TermsContent';
import { actions as popupActions } from '../../redux/ui/popup';
import { actions as formInProgressActions } from '../../redux/ui/formInProgress';
import {
  popupSecondaryContentVisibilitySelector,
  uiFormInProgressSelector,
} from '../../redux/ui/selectors';
import { loggedUserCountrySelector } from '../../redux/context/selectors';
import {
  privacyListSelector,
  sendingPrivacySelector,
} from '../../redux/data/selectors';
import {
  AUTH,
  COMMON,
  DIALOG_TITLE,
  TOGGLE_TNC,
} from '../../constants/strings';

import styles from './index.styl';

const mapStateToProps = state => ({
  termsVisible: popupSecondaryContentVisibilitySelector(state),
  formInProgress: uiFormInProgressSelector(state),
  privacyList: privacyListSelector(state),
  loggedUserCountry: loggedUserCountrySelector(state),
  sending: sendingPrivacySelector(state),
});

const mapDispatchToProps = {
  toggleTerms: popupActions.toggleContent,
  addForm: formInProgressActions.add,
  clearForm: formInProgressActions.delete,
};

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class Form extends Component {
  static propTypes = {
    error: PropTypes.object,
    inviteMessage: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    isFormValid: PropTypes.func.isRequired,
    closeInvitePopup: PropTypes.func.isRequired,
    clearErrors: PropTypes.func,
    invitePopupVisible: PropTypes.bool,
    children: PropTypes.any,
    termsAnchor: PropTypes.string,
    toggleTerms: PropTypes.func,
    termsVisible: PropTypes.bool,
    addForm: PropTypes.func,
    formInProgress: PropTypes.object,
    clearForm: PropTypes.func,
    formatMessage: PropTypes.func,
    privacyList: PropTypes.array,
    loggedUserCountry: PropTypes.string,
    sending: PropTypes.bool,
    hideTerms: PropTypes.bool,
  };

  static defaultProps = {
    onError: () => {},
  };

  state = {
    accepted: !!this.props.formInProgress.termsAndConditionsAccepted,
    serializedForm: {},
    disabled: true,
    contentType: '',
  };

  componentWillMount() {
    const { isFormValid, formInProgress } = this.props;
    this.setState({ disabled: !isFormValid(formInProgress) });
  }

  componentWillUnmount() {
    const { error, invitePopupVisible, clearErrors, clearForm } = this.props;

    if (error && !invitePopupVisible && typeof clearErrors === 'function') {
      clearErrors();
    }

    clearForm && clearForm(); // eslint-disable-line no-unused-expressions
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault();
    this.setState(
      {
        serializedForm: serialize(this.form, { hash: true }),
      },
      () => {
        this.props.onSubmit(this.state.serializedForm);
      },
    );
  }

  @autobind
  handleChange() {
    const formData = serialize(this.form, { hash: true });

    this.setState({ disabled: !this.props.isFormValid(formData) });
  }

  @autobind
  changeTermsAccepted() {
    this.setState({ accepted: !this.state.accepted });
  }

  @autobind
  closePopup(e) {
    e.preventDefault();
    this.props.closeInvitePopup();
  }

  @autobind
  handlePopupChange(type) {
    this.setState({
      contentType: type,
    });
    const form = serialize(this.form, { hash: true });
    this.props.addForm(form);
    this.props.toggleTerms();
  }

  handlePrivacyText = country => {
    const { sending, privacyList } = this.props;
    return (
      !sending && privacyList.find(item => get(item, 'country') === country)
    );
  };

  render() {
    const { disabled, contentType } = this.state;
    const {
      inviteMessage,
      children,
      onError,
      termsVisible,
      toggleTerms,
      formatMessage,
      loggedUserCountry,
      hideTerms,
    } = this.props;
    const errorMessage = onError();
    const defaultPrivacy = this.handlePrivacyText('USA');
    // TODO temporary privacyList contain only USA
    const privacyText = defaultPrivacy;

    return (
      <div>
        <form
          onSubmit={this.handleSubmit}
          onChange={this.handleChange}
          onMouseUp={this.handleChange}
          ref={node => (this.form = node)}
        >
          <div className={classNames('pb4', { dn: termsVisible })}>
            <p styleName="circles-popup-text">{inviteMessage}</p>
            {children}
            <If condition={errorMessage}>
              <ErrorBlock className="mb4" errors={errorMessage} />
            </If>
            {!hideTerms && (
              <div styleName="checkboxWrapper">
                <input
                  id="terms-input"
                  className="mr2"
                  name="termsAndConditionsAccepted"
                  checked={this.state.accepted}
                  type="checkbox"
                  value
                  onChange={this.changeTermsAccepted}
                />
                <label htmlFor="terms-input">
                  {formatMessage(AUTH.actions.tnc.textTitle)}
                </label>
                <a
                  styleName="link--acceptable"
                  onClick={() => this.handlePopupChange('privacy')}
                  className="mr2"
                >
                  {formatMessage(COMMON.privacy)}
                </a>
                <span styleName="text">{formatMessage(DIALOG_TITLE.and)}</span>
                <a
                  styleName="link--acceptable"
                  onClick={() => this.handlePopupChange('terms')}
                >
                  {formatMessage(AUTH.actions.tnc.textLink)}
                </a>
              </div>
            )}
            <Button
              type="submit"
              className="mt3 mr2"
              raised
              color="primary"
              disabled={disabled}
            >
              {formatMessage(COMMON.invite)}
            </Button>
            <Button
              className="mt3"
              raised
              color="accent"
              type="button"
              onClick={this.closePopup}
            >
              {formatMessage(COMMON.cancel)}
            </Button>
          </div>
          <If condition={termsVisible}>
            <TermsContent
              content={
                contentType === 'terms'
                  ? privacyText.terms
                  : privacyText.privacyPolicy
              }
            />
            <Button
              className="mt3"
              raised
              color="primary"
              onClick={() => toggleTerms()}
            >
              {formatMessage(TOGGLE_TNC)}
            </Button>
          </If>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CirclesLayout/InviteForm.jsx